import type { LeadRulesAggregation } from '@viq-admin/types';
import { adminFetch } from './dataProvider';

export interface AggregationsResponse {
  kpi: {
    total_scans:     number;
    total_notes:     number;
    total_tasks:     number;
    meetings_booked: number;
    /** The event's scans goal (Event Plan, not built yet); null or absent → plain Scans tile. */
    scans_goal?:     number | null;
  };
  coverage: {
    repeat_visitors:  number;
    vip_count:        number;
    unique_scans:     number;
    unique_companies: number;
  };
  /** Notes readiness for the Notes tile (spec 2026-09-14 §2.2). */
  leadRules?: LeadRulesAggregation | null;
}

export async function fetchAggregations(conferenceId: string): Promise<AggregationsResponse> {
  return adminFetch<AggregationsResponse>(
    `/v1/admin/conferences/${conferenceId}/aggregations`,
  );
}
